/* ===========================
   VMFS Option 2 (fixed)
   Move Snap Compare APP wrapper next to Quick View
   - Moves div[data-v-app] that contains .sp-button-compare (keeps Vue mount intact)
   - Styles button as icon overlay
   - Prevents card navigation WITHOUT killing Snap delegated events
   =========================== */

(function () {
  const CFG = {
    quickViewSelector: ".quick-view__button",
    snapBtnSelector: ".sp-button-compare",
    snapAppWrapperSelector: "div[data-v-app]",
    offsetRightPx: 56
  };

  function ensureStyleTag() {
    if (document.getElementById("vmfs-snap-compare-style")) return;

    const css = `
/* Ensure overlay parent can position */
.vmfs-snap-compare-overlay-parent{ position: relative !important; }

/* Move the Vue app wrapper, not just the button */
.vmfs-snap-compare-app{
  position: absolute !important;
  top: 0 !important;
  right: ${CFG.offsetRightPx}px !important;
  z-index: 6 !important;
}

/* Make Snap button look like Concept icon button */
.vmfs-snap-compare-app .sp-button-compare{
  width: 44px !important;
  height: 44px !important;
  padding: 0 !important;
  margin: 0 !important;

  border-radius: 999px !important;
  display: grid !important;
  place-items: center !important;

  /* keep Snap colors but remove full-width button feel */
  --sp-width: auto !important;
}

/* Hide label text, keep icon only */
.vmfs-snap-compare-app .sp-button-compare span > span{
  display: none !important;
}

/* Normalize icon size */
.vmfs-snap-compare-app .sp-button-compare svg{
  width: 18px !important;
  height: 18px !important;
}
    `.trim();

    const style = document.createElement("style");
    style.id = "vmfs-snap-compare-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function moveForCard(card) {
    if (!card || card.nodeType !== 1) return;

    const quickViewBtn = card.querySelector(CFG.quickViewSelector);
    if (!quickViewBtn) return;

    const snapBtn = card.querySelector(CFG.snapBtnSelector);
    if (!snapBtn) return;

    // Find the Vue root wrapper that Snap mounts into
    const appRoot = snapBtn.closest(CFG.snapAppWrapperSelector);
    if (!appRoot) return;

    if (appRoot.dataset.vmfsMoved === "1") return;

    const overlayParent = quickViewBtn.parentElement;
    if (!overlayParent) return;

    overlayParent.classList.add("vmfs-snap-compare-overlay-parent");

    // Delay move a tick to avoid racing with Vue mount updates
    setTimeout(() => {
      if (appRoot.dataset.vmfsMoved === "1") return;

      overlayParent.appendChild(appRoot);
      appRoot.classList.add("vmfs-snap-compare-app");
      appRoot.dataset.vmfsMoved = "1";

      // Prevent the product card link from navigating when clicking compare
      // IMPORTANT: do NOT stopPropagation, Snap may rely on delegated handlers
      appRoot.addEventListener(
        "click",
        function (e) {
          const btn = e.target.closest(CFG.snapBtnSelector);
          if (!btn) return;
          e.preventDefault();
        },
        true
      );
    }, 0);
  }

  function moveAll() {
    ensureStyleTag();

    // Find Snap buttons, move their wrappers per card
    document.querySelectorAll(CFG.snapBtnSelector).forEach((btn) => {
      const card =
        btn.closest(".product-card") ||
        btn.closest(".card.product-card") ||
        btn.closest(".card");
      if (!card) return;
      moveForCard(card);
    });
  }

  // Run initially
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", moveAll);
  } else {
    moveAll();
  }

  // Watch for Snap injecting buttons later
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!node || node.nodeType !== 1) continue;

        if (
          (node.matches && node.matches(CFG.snapBtnSelector)) ||
          (node.querySelector && node.querySelector(CFG.snapBtnSelector))
        ) {
          moveAll();
          return;
        }
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();